export default __webpack_public_path__ + "static/tag-dont-4-light-9a1a4c3955349c84f1e9472f31f9e087.png";